import {
    CoralConfigOptions,
    CoralColors,
    defaultTheme,
} from '@krakentech/coral';

const techZeroColors = {
    green: {
        main: '#11743C',
        dark: '#0c532b',
    },
    white: {
        main: '#FFFFFF',
    },
    black: {
        main: '#000000',
    },
};

const colors: Partial<CoralColors> = {
    base: {
        main: techZeroColors.black.main,
        dark: techZeroColors.black.main,
    },
    primary: {
        main: techZeroColors.white.main,
        light: techZeroColors.white.main,
        dark: 'red',
        intense: techZeroColors.green.main,
    },
    secondary: {
        main: techZeroColors.green.main,
        light: techZeroColors.green.main,
        dark: techZeroColors.green.main,
    },
    tertiary: {
        main: techZeroColors.white.main,
        light: techZeroColors.white.main,
    },
    text: {
        main: techZeroColors.white.main, //change this to green and just look at blog page why does this change everything 😭
        light: techZeroColors.green.main,
        dark: techZeroColors.green.main,
    },
};

const theme: Partial<CoralConfigOptions> = {
    overrides: {
        animation: {
            easing: 'ease-out',
            durationMs: 250,
        },
        borderWidth: '0.1rem',
        borderRadius: '1.2rem',
        color: colors,
        components: {
            chip: {
                tertiary: {
                    color: techZeroColors.green.main,
                },
            },
            textfield: {
                color: techZeroColors.green.main,
            },
            button: {
                root: {
                    backgroundColor: techZeroColors.green.main,
                    color: techZeroColors.white.main,
                    border: `0.2rem solid ${techZeroColors.green.main}`,
                    fontSize: '1.8rem',
                    ':hover': {
                        backgroundColor: techZeroColors.green.dark,
                        borderColor: techZeroColors.green.dark,
                    },
                    ':active': {
                        backgroundColor: techZeroColors.green.dark,
                        borderColor: techZeroColors.green.dark,
                    },
                    ':focus-visible': {
                        backgroundColor: techZeroColors.green.main,
                        borderColor: techZeroColors.white.main,
                    },
                },
                primary: {
                    outlined: {
                        backgroundColor: techZeroColors.black.main,
                        ':hover': {
                            backgroundColor: techZeroColors.black.main,
                            borderColor: techZeroColors.white.main,
                            color: techZeroColors.white.main,
                        },
                        ':active': {
                            backgroundColor: techZeroColors.green.dark,
                            borderColor: techZeroColors.green.dark,
                        },
                        ':focus-visible': {
                            backgroundColor: techZeroColors.green.main,
                            borderColor: techZeroColors.white.main,
                            color: techZeroColors.white.main,
                        },
                    },
                },
            },
        },
        name: 'Tech Zero',
        spacing: {
            ...defaultTheme.spacing,
            sm: '1.2rem',
            md: '2rem',
        },
        typography: {
            ...defaultTheme.typography,
            fontFamily: '"DM Sans", Arial, Helvetica, sans-serif',
        },
    },
};

export default theme;
